'use client';

import cx from 'clsx';

import BlogCard from '@/components/BlogCard';
import HorizontalSlider from '@/components/HorizontalSlider';
import SliderSection from '@/components/SliderSection';
import { BlogCategory, BlogPost } from '@/types/blog.type';

import styles from './CategoriesBlogSection.module.scss';

interface CategoriesBlogSectionProps {
  title: string;
  categories: BlogCategory[];
  posts: BlogPost[];
  titleVariant?: 'h2' | 'h3' | 'h4';
  spacingBottom?: boolean;
}

const CategoriesBlogSection = ({
  title,
  titleVariant = 'h2',
  categories,
  posts,
  spacingBottom = false,
}: CategoriesBlogSectionProps) => {
  const filteredPosts = posts.filter(post => categories.some(cat => post.categories.includes(cat)));

  if (filteredPosts.length === 0) {
    return null;
  }

  return (
    <SliderSection
      title={title}
      titleVariant={titleVariant}
      customStyles={{ container: cx(styles.container, { [styles.spacingBottom]: spacingBottom }) }}
    >
      {handleSwiper => (
        <HorizontalSlider
          data={filteredPosts}
          handleSwiper={handleSwiper}
          customStyles={{ slide: styles.slide }}
          renderItem={(post: BlogPost) => (
            <BlogCard
              slug={post.slug}
              image={post.cardImage}
              imageAlt={post.title}
              date={post.date}
              readTime={post.readTime}
              title={post.title}
              author={post.author}
            />
          )}
        />
      )}
    </SliderSection>
  );
};

export default CategoriesBlogSection;
